import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { useProto } from '../../contexts/PrototypeContext';
import { programInfo } from '../../data/program';
import { formatMoney } from '../../utils/format';
import { Annotation } from '../shared/Annotation';
export function ConfirmationStep() {
  const {
    state,
    cart,
    actions
  } = useProto();
  const claimed = state.reservation.status === 'claimed';
  const paid = claimed ? Math.max(0, cart.total - state.config.amount) : cart.total;
  return <div className="mx-auto max-w-[560px] space-y-5 px-5 py-10 text-center font-i9" data-id="element-260" data-mp="3nscuma75w0ok">
      <CheckCircle2Icon className="mx-auto h-14 w-14 text-i9-steel" aria-hidden="true" data-id="element-261" data-mp="5dakj3lvnclo" />
      <div data-id="element-262" data-mp="ehbpohjc9ru">
        <h1 className="text-[24px] font-bold text-i9-ink" data-id="element-263" data-mp="dz45vpfa94m">You're registered!</h1>
        <p className="mt-1 text-[15px] text-i9-muted" data-id="element-264" data-mp="fbriwln5athr">Mason and Ava are registered for {programInfo.name}.</p>
      </div>
      <dl className="space-y-2 rounded-lg border border-i9-line bg-i9-surface p-4 text-left text-[14px]" data-id="element-265" data-mp="ad6q37a83c3c">
        <div className="flex justify-between" data-id="element-266" data-mp="2g4uyhs8da8pj">
          <dt className="text-i9-muted" data-id="element-267" data-mp="2g661hptzncfl">Total paid</dt>
          <dd className="font-bold tabular-nums text-i9-ink" data-id="element-268" data-mp="2l2ediucw2pij">{formatMoney(paid)}</dd>
        </div>
        {claimed && <div className="flex justify-between" data-id="element-269" data-mp="2p37ypfyy5q7q">
            <dt className="text-i9-greenInk" data-id="element-270" data-mp="2u3m934o0tc8x">Volunteer Registration Discount</dt>
            <dd className="font-semibold tabular-nums text-i9-greenInk" data-id="element-271" data-mp="2u1hvtw48f0vz">{formatMoney(-state.config.amount)}</dd>
          </div>}
      </dl>
      <Annotation kind="rule" title="Upfront incentive · no clawback" className="text-left" data-id="element-272" data-mp="3410co3oui6jt">
        Checkout converted the reservation to claimed (see Connect). No recapture, new charge, or later balance if the volunteer doesn't coach. Volunteering later never earns a retroactive discount.
      </Annotation>
      <div className="flex flex-col gap-2" data-id="element-273" data-mp="3hurlf9ur5meh">
        <button type="button" onClick={() => actions.setView('connect')} className="bg-i9-steel py-3 text-[15px] font-bold text-white transition-colors hover:bg-i9-steelDark" data-id="element-274" data-mp="3msjdq4zb7aj7">
          See the claim in Connect
        </button>
        <button type="button" onClick={actions.restartRegistration} className="py-2.5 text-[14px] font-semibold text-i9-steel transition-colors hover:text-i9-steelDark" data-id="element-275" data-mp="1hrpbb43d5smd">
          Start a new registration
        </button>
      </div>
    </div>;
}